import React from "react";
import { useParams } from "react-router-dom";
import AssetCategoryPage from "./AssetCategoryPage";

const DynamicAssetCategory = () => {
  const { categoryName } = useParams();

  // Normalize the category name for title display
  // e.g., "facility-assets" -> "Facility Assets"
  // But for the database query, we often need the exact name
  const title = categoryName
    ? categoryName
        .split("-")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
    : "";

  // If the URL is "assets/facility", title is "Facility"
  // This should match the name in the database categories
  return <AssetCategoryPage category={title} title={title} />;
};

export default DynamicAssetCategory;
